import { preloadSpacesDropdown } from '@confluence/spaces-dropdown/entry-points/preloadSpacesDropdown';
import { preloadWebPanelLocation } from '@confluence/web-panel-location/entry-points/preloadWebPanelLocation';

import { preloadWelcomeMessages } from './RightPanel/WelcomeMessage/preloadWelcomeMessages';
import { preloadHomeWidgets } from './preloadHomeWidgets';

export const preloadSidePanel = ({
	isLicensed,
	isMyVisitedSpacesEnabled = false,
	isHomeRefreshEnabled = false,
}: {
	isLicensed: boolean;
	isMyVisitedSpacesEnabled?: boolean;
	isHomeRefreshEnabled?: Boolean;
}) => {
	const preloadQueries = [preloadHomeWidgets({ isLicensed })];

	// when refresh is on, welcome / announcements, apps and spaces will not be in sidebar
	!isHomeRefreshEnabled &&
		preloadQueries.push(
			preloadWelcomeMessages(),
			preloadWebPanelLocation({
				location: 'atl.dashboard.secondary',
				spaceKey: undefined,
			}),
			preloadSpacesDropdown({ isLicensed, isMyVisitedSpacesEnabled }),
		);

	return Promise.all(preloadQueries);
};
